import React from 'react';
import Header from '../common/Header'; // Ensure the path is correct
import SubHeader from '../common/SubHeader';
import '../styles/HomePage.css';
import TransactionReports from '../transactionreports/TransactionReports';
import { useLocation } from "react-router-dom";
import { useLanguage } from './../common/LanguageContext';
const ReuseHeaderandBeardcrum = ({Children}) => {
  const location = useLocation();
  const srvId=location.state?.srvId;
  const { language } = useLanguage();
 
  return (
    <div className='container-fluid d-flex flex-column w-100 p-0 m-0'>
      <Header />
      <div className='bg-secondary'><SubHeader /></div>
      <div style={{padding:"10px", borderRadius:"10px"}}>
      <TransactionReports srvId={srvId} language={language}/>
      </div>
    </div>
  );
};

export default ReuseHeaderandBeardcrum;
